import styled from 'styled-components';
import { COLORS } from '../../../constants/radar';

export const TagsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  max-width: 100%;
  overflow-x: auto;
  padding: 4px 0;

  scrollbar-width: thin;
  
  &::-webkit-scrollbar {
    height: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 3px;
  }
`;

export const TagOption = styled.button`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 6px 12px;
  margin: 2px 0;
  border: 1px solid ${props => props.selected ? COLORS.PRIMARY : '#ddd'};
  background-color: ${props => props.selected ? `${COLORS.PRIMARY}10` : '#fff'};
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
  color: ${COLORS.PRIMARY};
  font-weight: 500;

  &:hover {
    background-color: ${props => props.selected ? `${COLORS.PRIMARY}20` : COLORS.BACKGROUND};
  }
`;

export const TagIcon = styled.span`
  margin-right: 8px;
  display: inline-flex;
  align-items: center;
  color: ${COLORS.SECONDARY};
`;

export const TagCount = styled.span`
  margin-left: 4px;
  font-size: 0.8em;
  color: ${COLORS.SECONDARY};
`; 